import type React from "react";

import { LinearProgress, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

import { Container } from "../EarningsWidget/styles";

interface EnrolledPatientsProps {
  children?: React.ReactNode;
  enrollmentGoal?: number;
  patientsEnrolled?: number;
}

export const EnrolledPatients: React.FC<EnrolledPatientsProps> = ({
  children,
  enrollmentGoal = 10,
  patientsEnrolled = 0,
}) => {
  const { t } = useTranslation();

  const calculatePercentage = (enrolledPatients?: number) => {
    if (!enrolledPatients) {
      return 0;
    }

    const percentage = (enrolledPatients / enrollmentGoal) * 100;
    if (percentage > 100) {
      return 100;
    }
    return percentage;
  };

  return (
    <Container>
      <Typography variant="h3">{t("earnings_widget.enrolled_patients.header")}</Typography>
      <Progress>
        <LinearProgress variant="determinate" value={calculatePercentage(patientsEnrolled)} />
        <Typography variant="subtitle1">
          {patientsEnrolled}/{enrollmentGoal}
        </Typography>
      </Progress>
      {children}
    </Container>
  );
};

const Progress = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 24px;
  margin-bottom: 8px;

  .MuiLinearProgress-root {
    height: 15px;
    width: 100%;
    border-radius: 15px;
  }

  .MuiLinearProgress-colorPrimary {
    background: ${({ theme }) => theme.colors.redesign.db10};
  }

  .MuiLinearProgress-barColorPrimary {
    background: ${({ theme }) => theme.colors.redesign.g100};
    border-radius: 15px;
  }
`;
